import React, { useEffect, useRef, useState } from 'react';
import { translate } from "../Services/translation";
import { Svg } from "./Svg";

/**
 * @typedef {Object} SearchResultItem
 * @property {string} id - The unique identifier for the search result item (GUID).
 * @property {string} name - The name of the search result item.
 * @property {string} url - The URL associated with the search result item.
 * @property {number} score - The score of the search result item.
 * @property {string} type - The type of the search result item.
 */

/**
 *
 * @param {SearchResultItem} searchResultItem
 * @param refForward
 * @returns {Element}
 */
const SearchResultItemPill = ({searchResultItem, refForward}) => {
    return (
        <a href={searchResultItem.url}
           title={searchResultItem.name}
           className="search-result__item-pill"
           ref={refForward}
        >
            {searchResultItem.name}
        </a>
    );
}

/**
 *
 * @param categoriesResult[] categoriesResult
 * @returns {Element}
 */
const SearchResultCategories = ({categoriesResult}) => {
    const activeClass = ' is-open';
    const [open, setOpen] = useState(false);
    const [itemsThatFit, setItemsThatFit] = useState(1);
    const containerRef = useRef(null);
    const childrenRefs = useRef([]);

    const onClick = () => {setOpen(!open)}

    useEffect(() => {
        const calculateItemsPerRow = () => {
            if (containerRef.current && childrenRefs.current.length > 0) {
                const containerWidth = containerRef.current.offsetWidth;
                let totalWidth = 0;
                let count = 0;
                const childMargin = 10; // Adjust this if the margin-right changes

                for (let child of childrenRefs.current) {
                    const childWidth = child.offsetWidth;
                    if (totalWidth + childWidth + (count > 0 ? childMargin : 0) <= containerWidth) {
                        totalWidth += childWidth + (count > 0 ? childMargin : 0);
                        count++;
                    } else {
                        break;
                    }
                }

                if (count <= 0) {
                    count = 1;
                }
                setItemsThatFit(count);
            }
        };

        // Initial calculation
        calculateItemsPerRow();

        // Recalculate on window resize
        window.addEventListener('resize', calculateItemsPerRow);
        return () => {
            window.removeEventListener('resize', calculateItemsPerRow);
        };
    }, [categoriesResult]);

    if (categoriesResult.length === 0) return null;

    let resultIsMoreThanFits = itemsThatFit < categoriesResult.length;

    return (
        <div className={'row search-result-page__categories-preview' + ((open || !resultIsMoreThanFits) ? activeClass : '')}>
            <div className="columns small-12" ref={containerRef}>
                {categoriesResult.length && categoriesResult.map((searchResultItem, index) => (
                    <SearchResultItemPill
                        key={searchResultItem.id}
                        searchResultItem={searchResultItem}
                        refForward={el => childrenRefs.current[index] = el}
                    />
                ))}
            </div>

            {categoriesResult.length > itemsThatFit && (
                <div className="columns small-12">
                    <span className="search-result-page__show-more-categories" onClick={onClick}>
                        {open ?
                            translate("nmas.searchresult.categories.label.showless") :
                            translate("nmas.searchresult.categories.label.showmore").replace('{count}', categoriesResult.length)}

                        <Svg icon="chevron" extraClass={open ? 'chevron-up' : 'chevron-down'}/>
                    </span>
                </div>
            )}
        </div>
    );
}

export default SearchResultCategories;